import axios from 'axios';
import qs from 'qs';
import { generateFormData, getHeaderConfig } from './util';
import { createRamNum } from './util';
import router from '../router'
import keycloak from '@/utils/keycloak.js'
import {updateToken} from '@/utils/auth'
// import { Message } from 'element-ui';
export const { CancelToken } = axios;
const instance = axios.create({withCredentials: true});
instance.defaults.timeout = 60 * 1000;
axios.defaults.headers.common['Cookie'] = 'SameSite-Policy=None';
const loginOrigin = localStorage.getItem('loginOrigin')||null;
/**
 * 解决cancelToken执行后，progress一直显示加载
 */
const cancelTokenMap = {};
let currentCancelId = null;
/**
 * 请求发起前的拦截器
 * @param config
 * @returns {*}
 */
async function beforeStart(config) {
    if (loginOrigin==='keycloak') {
        await updateToken()
    }
    if (config.cancelToken && currentCancelId) {
        cancelTokenMap[currentCancelId] = config.$requestId;
        currentCancelId = null;
    }
    return config;
}

/**
 * 统一拦截所有失败的请求
 * @param error
 * @returns {Promise<never>}
 */
function onFailure(error) {
    if (error && error.response) {
        console.log(error.response,'新框架接口超时')
        if(error.response.status === 401 || error.response.status === 417){
            // console.log('ceshi002')
            // localStorage.clear();
            // router.replace('/login',()=>{
            //     location.reload();
            // })
            if (loginOrigin==='keycloak') {
                updateToken()
            }
        }
    }
    return Promise.reject(error.response.data);
}

/**
 * 统一拦截所有成功的请求
 * @param error
 * @returns {Promise<never>}
 */
function onSuccess(res) {
    // 统一处理业务错误码
    if (res && res.data.code && [10001].includes(res.data.code)) {
        // Message.error(res.data.message);
        // keycloak.logout()
        // localStorage.clear();
        router.replace('/403', () => {
            location.reload();
        });
        return Promise.reject(res);
    } else if (res && res.data.code && [ 10002, 10003].includes(res.data.code)) {
        if (loginOrigin==='keycloak') {
            updateToken()
        }
        return Promise.reject(res);
    }
    if (res.data != undefined) {
        return res.data;
    }
    return res;
}
instance.interceptors.request.use(beforeStart, onFailure);
instance.interceptors.response.use(onSuccess, onFailure);
instance.interceptors.request.use(
    (config) => {
        const { paramsSerializer } = config;
        let { url } = config;
        const { params } = config;
        if (
            (config.method === 'post' || config.method === 'put' || config.method === 'patch') &&
            typeof paramsSerializer === 'function'
        ) {
            config.data = paramsSerializer(config.data);
        }
        // query参数编码
        if (params) {
            url += '?';
            const keys = Object.keys(params);
            for (const key of keys) {
                url += `${key}=${encodeURIComponent(params[key])}&`;
            }
            url = url.substring(0, url.length - 1);
            config.params = null;
        }
        const token = localStorage.getItem('token')
        if(token){
            config.headers['Authorization'] = token
        }

        config.url = url;
        return config;
    },
    (error) => {
        return Promise.reject(error.response.data);
    },
);
const request = {
    get: (url, params, opts, method) => {
        const paramsSerializer = (params) => {
            return qs.stringify(params);
        };

        if (!opts.paramsSerializer) {
            opts.paramsSerializer = paramsSerializer;
        }
        const config = {
            url,
            method,
            params,
            ...opts,
        };
        return instance.request(config);
    },
    post: (url, params, opts, method) => {
        let paramsSerializer;
        const contentType = opts.contentType || 'json';
        const config = {
            headers: getHeaderConfig(method, contentType, opts.headers || {}),
            ...opts,
        };
        if (contentType === 'json') {
            paramsSerializer = (params) => params;
        }
        if (contentType === 'form') {
            paramsSerializer = (params) => qs.stringify(params);
        }
        if (contentType === 'file' && !(params instanceof FormData)) {
            paramsSerializer = (params) => generateFormData(params);
        }
        if (contentType === 'file' && params instanceof FormData) {
            paramsSerializer = (params) => params;
        }
        config.method = method;
        config.data = params;
        config.paramsSerializer = paramsSerializer;
        return instance.request(url, config);
    },
};

const myRequest = (url, params, opts, method) => myRequest.get(url, params, opts, method);

['post', 'get', 'put', 'patch', 'delete'].forEach(
    (method) => {
        myRequest[method] = (url, params, opts = {}) => {
            let aliasMethod = method;
            if (aliasMethod === 'put' || aliasMethod === 'patch') {
                aliasMethod = 'post';
            }
            if (aliasMethod === 'delete') {
                aliasMethod = 'get';
            }
            return request[aliasMethod](url, params, opts, method);
        };
    });
// 当前cancelToken对应的id
myRequest.getCancelId = () => {
    return (currentCancelId = createRamNum());
};
myRequest.clearCancel = () => {
    // progress.done(cancelTokenMap[id]);
};

export default myRequest;
